/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index modal to autogenerate all the components and extensions
 * Used by "prepareModals"
 */

import Modal from './modal/Modal'
export * from './modal/Modal'
export default Modal
